// @ts-nocheck
// TODO: Fix why antdForm wont take in FormProps from antd lib
import React, { FunctionComponent } from 'react';
import { Form as AntdForm } from 'antd';
import { FormProps } from 'antd/lib/form';

const Form: FunctionComponent<FormProps> = (props) => <AntdForm {...props} />;

export default Form;
